import { Logger } from '../../../logger/Logger';
import type { CoreStoreType } from '../../../store/CoreStore';
import { configActions } from '../../../store/slices/config/slice';
import type { GameMessage, IGameCommunicationProcessor } from '../types';

export class GameCommunicationSwitchProcessor implements IGameCommunicationProcessor {
  messageName = 'switch';
  delay = 0;

  process(message: GameMessage, store: CoreStoreType): void {
    if (
      message.httpAddress &&
      typeof message.httpAddress === 'string' &&
      message.wsAddress &&
      typeof message.wsAddress === 'string'
    ) {
      Logger.logEvent('click', 'serverSwitchRequested', Date.now(), 1, '', false);
      store.dispatch(
        configActions.setGameServer({
          httpAddress: message.httpAddress,
          wsAddress: message.wsAddress,
        })
      );
    }
  }
}
